export default __webpack_public_path__ + "static/media/style.css.22c04889.map";